import { useState, useEffect } from 'react';
import { getSyncStatus, onSyncStatusChange, type SyncStatus } from '../db/sync-queue';
import { getPendingOps } from '../db/database';

export function useSync() {
  const [syncStatus, setSyncStatus] = useState<SyncStatus>(getSyncStatus());
  const [pendingCount, setPendingCount] = useState(0);

  useEffect(() => {
    const unsub = onSyncStatusChange(setSyncStatus);
    return unsub;
  }, []);

  useEffect(() => {
    const updateCount = () => {
      getPendingOps().then((ops) => setPendingCount(ops.length));
    };
    updateCount();

    const onOpsChanged = () => updateCount();
    window.addEventListener('barter:ops-changed', onOpsChanged);
    const unsub = onSyncStatusChange(() => updateCount());
    return () => {
      window.removeEventListener('barter:ops-changed', onOpsChanged);
      unsub();
    };
  }, []);

  return { syncStatus, pendingCount };
}
